export function toggleToolbar(selector) {
    const toggle_selector = selector.querySelectorAll('.toolbar-toggle')
    const body_selector = document.querySelector('body')

    toggle_selector.forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault()

            const parent = item.closest('.toolbar-item')

            if (parent.classList.contains('show')) {
                parent.classList.remove('show')
                body_selector.classList.remove('active-toolbar')
            } else {
                parent.classList.add('show')
                body_selector.classList.add('active-toolbar')

                // Autofocus if item is search
                const search_input = parent.querySelector('#searchInput')
                if (search_input) {
                    search_input.focus()
                }
            }
        })
    })
}

export function checkAllCategories(selector) {
    const categories_selector = selector.querySelector('.toolbar-filter-group-categories')

    if (categories_selector) {
        const all_selector = categories_selector.querySelector('#toolbar-filter-categories-all')
        const checkboxes = categories_selector.querySelectorAll(
            'input[type=checkbox]:not(#toolbar-filter-categories-all)'
        )
        const checkboxes_count = checkboxes.length
        let active_checkboxes = 0

        all_selector.addEventListener('change', (event) => {
            checkboxes.forEach((item) => {
                item.checked = !!event.target.checked
            })

            if (event.target.checked) {
                active_checkboxes = checkboxes_count
            } else {
                active_checkboxes = 0
            }
        })

        checkboxes.forEach((item) => {
            // check how many checkboxes are checked
            if (item.checked) {
                active_checkboxes++
            }

            item.addEventListener('change', (event) => {
                // Uncheck "all categories" if one checkbox was unchecked
                if (!event.target.checked) {
                    all_selector.checked = false
                    active_checkboxes--
                } else {
                    active_checkboxes++
                }

                // Check if all categories where selected
                if (active_checkboxes === checkboxes_count) {
                    all_selector.checked = true
                }
            })
        })
    }
}
